import { PlusIcon } from "@heroicons/react/20/solid";
import ProjectAction from "../actions/ProjectAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleOnClickProject } from "../AppBreadcrumb";
import { useContext, useEffect } from "react";
import { AppContext } from "../Contexts";
import Loading from "./Loading";
import { useTranslation } from "react-i18next";
import { getBaseUrl } from "../api/api";

export const WorkspaceEmptyState = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const appContext = useContext<any>(AppContext);
  const projects = useSelector((state: any) => state.projectReducer.get("projects"));
  const isLoadingProjects = useSelector((state: any) => state.projectReducer.get("pending"));
  const currentUser = useSelector((state: any) => state.userReducer.get("currentUser"));

  const handleAdd = () => {
    navigate("/workspaces/new");
  };

  useEffect(() => {
    document.title = t("Pipeline List");
    dispatch(ProjectAction.getProjects());
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (projects.size > 0) {
      const savedWorkspaceId = currentUser.get("currentWorkspaceId");
      const savedWorkspace = savedWorkspaceId
        ? projects.find((p) => p.get("id") === savedWorkspaceId)
        : null;
      const workspace = savedWorkspace ? savedWorkspace.toJS() : projects.get(0).toJS();
      handleOnClickProject(workspace, appContext, navigate);
    }
  }, [projects, appContext, navigate, currentUser]);

  if (isLoadingProjects) {
    return <Loading />;
  }

  return (
    <div className="text-center w-full mt-16">
      <div className="py-24 sm:py-32 lg:pb-40">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h1 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
              {t("The CRM that scales your business.")}
            </h1>
            <p className="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
              {t(
                "TypeCRM gives you complete control and flexibility to build the perfect CRM that drives revenue forward."
              )}
            </p>
          </div>
          <div className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={handleAdd}
              className="inline-flex cursor-pointer items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
              <PlusIcon className="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
              {t("New pipeline")}
            </button>
          </div>
          <div className="flow-root mt-6">
            <div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-gray-900/10 ring-inset lg:-m-4 lg:rounded-2xl lg:p-4">
              <img
                alt="App screenshot"
                src={`${getBaseUrl()}/static/images/landing/landing_deals.png`}
                className="rounded-md ring-1 shadow-2xl ring-gray-900/10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
